import * as React from 'react'

import { Hidden, Visible } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { CTASection } from '..'
import { LOCIZE_NAMESPACE } from '../../../../common'
import { SchoolPage_school as School } from '../../gql'
import { i18nKeyPrefix } from '../../i18n'
import { FullPricing } from '../Content'
import { CTASectionContainer } from '../CTASection'
import {
  Container,
  DetailsContainer,
  DirectorAvatar,
  DirectorName,
  HeaderLeft,
  HeaderRight,
  SchoolName,
} from './CTABar.styles'

const PRE = `${i18nKeyPrefix}-CTA-BAR`

interface IProps {
  school: School
}

export default function CTABar(props: IProps) {
  return (
    <Container>
      <Visible lg xl>
        <Desktop {...props} />
      </Visible>
      <Hidden lg xl>
        <Mobile {...props} />
      </Hidden>
    </Container>
  )
}

function Desktop(props: IProps) {
  const { school } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <>
      <HeaderLeft>
        <DirectorAvatar src={school.director ? school.director.avatarUrl : ''} />
        <DetailsContainer>
          <DirectorName>
            {school.director ? `${school.director.firstName} ${school.director.lastName}` : ''}
          </DirectorName>
          <FullPricing {...props} />
        </DetailsContainer>
      </HeaderLeft>

      <HeaderRight>
        <CTASectionContainer>
          <CTASection
            full={false}
            school={school}
            messageDirectorLabel={t(`${PRE}-MESSAGE`)}
            scheduleTourLabel={t(`${PRE}-TOUR`)}
          />
        </CTASectionContainer>
      </HeaderRight>
    </>
  )
}

function Mobile(props: IProps) {
  const { school } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <>
      <DetailsContainer>
        <SchoolName>{school.name}</SchoolName>
        <FullPricing {...props} />
      </DetailsContainer>
      <CTASectionContainer>
        <CTASection
          full={false}
          school={school}
          messageDirectorLabel={t(`${PRE}-MESSAGE`)}
          scheduleTourLabel={t(`${PRE}-TOUR`)}
        />
      </CTASectionContainer>
    </>
  )
}
